/**
 * @generated SignedSource<<84e419991b9eb5cb107453d0a12e2a99>>
 * @relayHash 259d6dfdea54bf21521feb6f3b625342
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fafe8277937c37575e176290181bbdf5073f5ce9705c348bb67afd85be56d7f4

import type { ConcreteRequest, Query } from 'relay-runtime';
export type lossAversionModalQuery$variables = {
  cloudId: string;
  cloudIds?: ReadonlyArray<string> | null | undefined;
  offeringKey?: string | null | undefined;
};
export type lossAversionModalQuery$data = {
  readonly jira: {
    readonly attachmentStorageUsed: AGG$Long | null | undefined;
  } | null | undefined;
  readonly tenantContexts: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly __typename: "CommerceEntitlementInfoCcp";
      readonly entitlement: {
        readonly experienceCapabilities: {
          readonly changeOffering: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly subscription?: {
          readonly chargeDetails: {
            readonly chargeQuantities: ReadonlyArray<{
              readonly quantity: number | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
};
export type lossAversionModalQuery = {
  response: lossAversionModalQuery$data;
  variables: lossAversionModalQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudIds"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offeringKey"
  }
],
v1 = {
  "concreteType": "JiraQuery",
  "kind": "LinkedField",
  "name": "jira",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "applicationKey",
          "value": "JIRA_SOFTWARE"
        },
        {
          "kind": "Variable",
          "name": "cloudId",
          "variableName": "cloudId"
        }
      ],
      "kind": "ScalarField",
      "name": "attachmentStorageUsed"
    }
  ]
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudIds",
    "variableName": "cloudIds"
  }
],
v3 = [
  {
    "kind": "Literal",
    "name": "hamsProductKey",
    "value": "jira-software.ondemand"
  }
],
v4 = [
  {
    "kind": "Variable",
    "name": "offeringKey",
    "variableName": "offeringKey"
  }
],
v5 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v6 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "concreteType": "CcpChargeDetails",
  "kind": "LinkedField",
  "name": "chargeDetails",
  "plural": false,
  "selections": [
    {
      "concreteType": "CcpChargeQuantity",
      "kind": "LinkedField",
      "name": "chargeQuantities",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "quantity"
        }
      ]
    }
  ]
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "lossAversionModalQuery",
    "selections": [
      (v1/*: any*/),
      {
        "args": (v2/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v4/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOffering",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v7/*: any*/),
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "CcpSubscription",
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "lossAversionModalQuery",
    "selections": [
      (v1/*: any*/),
      {
        "args": (v2/*: any*/),
        "concreteType": "TenantContext",
        "kind": "LinkedField",
        "name": "tenantContexts",
        "plural": true,
        "selections": [
          {
            "args": (v3/*: any*/),
            "kind": "LinkedField",
            "name": "entitlementInfo",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "name": "entitlement",
                "plural": false,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "experienceCapabilities",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      {
                        "args": (v4/*: any*/),
                        "kind": "LinkedField",
                        "name": "changeOffering",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/)
                        ]
                      }
                    ]
                  },
                  (v9/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "CcpEntitlement",
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "CcpSubscription",
                        "kind": "LinkedField",
                        "name": "subscription",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "type": "CommerceEntitlementInfoCcp"
              }
            ],
            "storageKey": "entitlementInfo(hamsProductKey:\"jira-software.ondemand\")"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "fafe8277937c37575e176290181bbdf5073f5ce9705c348bb67afd85be56d7f4",
    "metadata": {},
    "name": "lossAversionModalQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "32da0946b6e9f2dd6ca7ae739da7f654";

export default node;
